import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 75%, 100% {
    transform: scale(0);
    opacity: 0;
  }
  25%, 50% {
    transform: scale(1);
    opacity: 1;
  }
`;

const WarningIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  width: ${({ theme }) => theme.space.l};
  height: ${({ theme }) => theme.space.l};
  background: ${({ theme }) => theme.colors.feedback.selected};
  border: 2px solid white;
  position: absolute;
  top: ${({ theme }) => `calc(-${theme.space.l} / 2)`};
  left: ${({ theme }) => `calc(-${theme.space.l} / 2)`};

  &::after {
    content: '';
    border-radius: 50%;
    background: white;
    z-index: 2;
    width: ${({ theme }) => theme.space.s};
    height: ${({ theme }) => theme.space.s};
    animation: ${pulse} 1.8s ease-in-out infinite;
  }
`;

export default WarningIndicator;
